<template>
  <div class="asset-details-page">
    <div class="header">
      <h2 class="title">Asset Details</h2>
      <router-link class="back-link" :to="{ name: 'Layout' }">Back</router-link>
    </div>
    <p class="hint">Details for asset id: {{ id }}</p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const id = computed(() => String(route.params.id || 'unknown'))
</script>

<style scoped>
.asset-details-page { padding: 20px; }
.header { display: flex; align-items: center; justify-content: space-between; }
.title { margin: 0; font-size: 20px; font-weight: 600; }
.back-link { color: var(--primary-color); text-decoration: none; }
.hint { margin-top: 12px; color: var(--text-color-2); }
</style>


